import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"data-vuetify":""}},[_c(VApp,[_c(VMain,{staticClass:"campaign-page"},[(!_vm.data.campaign)?_c(VSkeletonLoader,{attrs:{"type":"table"}}):(_vm.data.campaign.sentAt)?_c('ViewCampaign',{attrs:{"campaign":_vm.data.campaign,"invites":_vm.campaignInvitations,"prevRoute":_vm.prevRoute}}):_c('CampaignStepper',{attrs:{"campaignData":_vm.data}})],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }